import { render, staticRenderFns } from "./root-pharmacy-orders.vue?vue&type=template&id=7574c609&scoped=true"
import script from "./root-pharmacy-orders.vue?vue&type=script&lang=js"
export * from "./root-pharmacy-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7574c609",
  null
  
)

export default component.exports